import '../newsItems.scss';
import ContentSearchPage from '../ContentSearchPage';
import AddArticleModal from './AddArticleModal';

const type = 'page,image,video,article';

const ArticlesPage = () => (
  <ContentSearchPage
    pageTitle="Articles"
    addItemModal={<AddArticleModal />}
    pageIcon="newspaper outline"
    contentType={type}
  />
);

export default ArticlesPage;
